var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "close_svg2__a",
    x1: 44.4,
    x2: 161.59,
    y1: 164.56,
    y2: 28.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M197.14 183.33 113.81 100l83.33-83.33c3.81-3.81 3.81-10 0-13.81s-10-3.81-13.81 0L100 86.19 16.67 2.86c-3.81-3.81-9.99-3.81-13.81 0s-3.81 10 0 13.81L86.19 100 2.86 183.33A9.76 9.76 0 0 0 0 190.24c0 5.39 4.37 9.76 9.77 9.76a9.78 9.78 0 0 0 6.91-2.86l83.33-83.33 83.33 83.33a9.78 9.78 0 0 0 13.82 0c3.81-3.81 3.81-10 0-13.81Z",
    style: {
      fill: "url(#close_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgClose;